import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.scss';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  
  // Hide footer on scanner pages (they have their own navigation)
  const isScannerPage = location.pathname.startsWith('/scanner/');
  
  if (isScannerPage) {
    return null;
  }

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <div className="footer-dropdown">
            <Link to="/about">About</Link>
            <div className="footer-dropdown-content">
              <Link to="/about">Our Story</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/host">Host Event</Link>
            </div>
          </div>
          <div className="footer-dropdown">
            <Link to="/contact">Contact</Link>
            <div className="footer-dropdown-content">
              <Link to="/contact">Support</Link>
              <Link to="/faq">FAQs</Link>
            </div>
          </div>
          <div className="footer-dropdown">
            <Link to="/privacy">Privacy</Link>
            <div className="footer-dropdown-content">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/refund">Refund Policy</Link>
            </div>
          </div>
          <div className="footer-dropdown">
            <Link to="/terms">Terms</Link>
            <div className="footer-dropdown-content">
              <Link to="/terms">Terms & Conditions</Link>
              <Link to="/privacy">Cookie Policy</Link>
            </div>
          </div>
        </div>
        <div className="footer-center">
          <Link to="/" className="footer-brand">
            <small className="copyright">© {currentYear} Quicket</small>
          </Link>
        </div>
        <div className="footer-right">
          <div className="social-links">
            <a href="https://www.facebook.com/quicket.official" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://instagram.com/quicket.me" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/company/quicket-me/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.youtube.com/@quicketme" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
